<template>
  <div>
    <Form :fnoname="'920.00'" :fnoperiod="'year'" :fnotitle="'Декларация для плательщиков единого земельного налога'"></Form>
  </div>
</template>

<script>
import Form from "@/components/fno/Form";
export default {
  name: "Fno920.00",
  components: {
    Form
  }
}
</script>

<style scoped>

</style>
